<template>
	<div>
		<pui-datatable :modelName="model" :actions="actions"></pui-datatable>
		<userappresetpassworddialog v-if="!isLdapActive" :modelName="model"></userappresetpassworddialog>
		<userAppModalsdialog :modelName="model"></userAppModalsdialog>
	</div>
</template>

<script>
import UserAppActions from './UserAppActions';
import UserAppResetPasswordDialog from './UserAppResetPasswordDialog';
import UserAppModals from './UserAppModals';

export default {
	name: 'userappgrid',
	components: {
		userappresetpassworddialog: UserAppResetPasswordDialog,
		userAppModalsdialog:UserAppModals
	},
	data() {
		return {
			model: 'userapp',
			actions: UserAppActions.actions
		};
	}
};
</script>
